Greenmile.KronosLog = Greenmile.KronosLog || {};
Greenmile.KronosLog.RejectInBatch = (function () {
    function RejectInBatch () {

        Monet.Grid.ActionsModules.ButtonEventCheckBox.apply(this, arguments);

        this.setValueBtn = function () {
            this.valueBtn = Monet.I18n.getResourcesByKey("Greenmile.Grid.KronosLog.RejectInBatch.btnValue");
        };

        const rejectLogs = (logs) => {
            try {
                App.Forms.KronosLog.pagination.first = 0;
                const grid = App.Forms.KronosLog.table;
                const ajax = new Monet.Ajax();
                ajax.url = `KronosLog/Reject`;
                ajax.method = "post";
                ajax.data = logs;
                ajax.success = () => {
                    grid.setSelectedRows([]);
                    App.Forms.KronosLog.filterBuilder.executeFilter();
                };
                ajax.error = (xhr) => {
                    if (xhr.responseText !== "") {
                        const response = JSON.parse(xhr.responseText);
                        App.Objects.KronosLog.showErrorExceptionOnPopupForm(response);
                    }
                };

                ajax.send();
            } catch (e) {
                new Monet.Exception.ReturnError(this, "Error on reject Kronos Logs").console();
            }
        }

        this.actionAfterClickButton = () => {

            try {
                const entityModel = App.Forms[this.entity];
                const grid = entityModel.table;
                const dataProvider = entityModel.dataProvider;

                if (grid === "undefined") {
                    return;
                }

                const rowsSelected = grid.getSelectedRows();

                if (rowsSelected.length <= 0) {
                    new Greenmile.Components.AlertModal("Greenmile.actionGridButton.noItemChecked")
                        .show();
                    return;
                }

                const confirmRejectAction = () => {
                    const logsSelected = [];
                    for (let i = 0; i < rowsSelected.length; i++) {
                        const item = dataProvider.getItem(rowsSelected[i]);
                        const status = item.model?.attributes?.status || '';
                        if (status === 'ERROR') {
                            logsSelected.push({ id: item.idOfObject });
                        }
                    }

                    if (logsSelected.length > 0) {
                        rejectLogs(logsSelected);
                    } else {
                        grid.setSelectedRows([]);
                        App.Forms.KronosLog.filterBuilder.executeFilter();
                    }
                };

                new Greenmile.Components.AlertModal("Greenmile.Grid.KronosLog.confirmReject",
                    null,
                    confirmRejectAction
                )
                .show();

            } catch (e) {
                new Monet.Exception.ReturnError(this, "Error on actionAfter click button.", e).console();
            }

        };
    }

    return RejectInBatch;
}());
